import React, { useMemo, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Input,
  Box,
  Text,
  Button,
  VStack,
  Icon,
} from '@chakra-ui/react';
import { FiCheck } from 'react-icons/fi';

export default function SearchListModal({
  modalHeading,
  options,
  isOpen,
  onClose,
  onSelect,
  selectedValue,
  displayKey = 'label',
  searchInputPlaceholder = 'Search...',
  zeroOptionsMessage = 'No options available',
}) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredOptions = useMemo(() => {
    const query = searchTerm.trim().toLowerCase();

    if (!query) {
      return options;
    }

    return options.filter((option) =>
      String(option[displayKey] || '')
        .toLowerCase()
        .includes(query),
    );
  }, [displayKey, options, searchTerm]);

  const handleClose = () => {
    setSearchTerm('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="md"
      isCentered
      scrollBehavior="inside"
    >
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent maxH="80vh" bg="white" color="gray.800" borderRadius="xl">
        <ModalCloseButton color="gray.600" />
        <ModalHeader
          fontSize="md"
          bg="white"
          color="#0F2137"
          borderBottom="1px solid"
          borderColor="gray.200"
          borderRadius="xl"
        >
          {modalHeading}
        </ModalHeader>
        <ModalBody pb={6} bg="white" borderRadius="xl">
          <Input
            mb={4}
            placeholder={searchInputPlaceholder}
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            bg="white"
            color="gray.800"
            borderColor="gray.300"
            _placeholder={{ color: "gray.400" }}
          />

          <VStack align="stretch" spacing={2} maxH="50vh" overflowY="auto">
            {filteredOptions.length === 0 && (
              <Text color="gray.500" fontSize="sm" textAlign="center" py={4}>
                {zeroOptionsMessage}
              </Text>
            )}

            {filteredOptions.map((option) => {
              const isSelected =
                selectedValue != null &&
                String(option.value) === String(selectedValue);

              return (
                <Button
                  key={option.value}
                  variant="outline"
                  justifyContent="space-between"
                  fontWeight="normal"
                  whiteSpace="normal"
                  textAlign="left"
                  h="auto"
                  py={3}
                  bg="white"
                  color="gray.700"
                  borderColor={isSelected ? '#3182ce' : 'gray.300'}
                  borderWidth={isSelected ? '2px' : '1px'}
                  _hover={{ bg: 'gray.50' }}
                  onClick={() => {
                    onSelect(option);
                    setSearchTerm('');
                  }}
                >
                  {String(option[displayKey] || '')}
                  {isSelected && (
                    <Icon as={FiCheck} color="#3182ce" boxSize={5} flexShrink={0} />
                  )}
                </Button>
              );
            })}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
